/**
 * Odstęp od dołu dla elementów pływających nad treścią na telefonie — pigułki
 * Lista/Mapa i noty o pinach poza kadrem. Jedna stała, żeby te dwa elementy nie
 * rozjechały się wysokością.
 *
 * HISTORIA, BO INACZEJ KTOŚ TO ZNOWU „NAPRAWI" W ZŁĄ STRONĘ:
 *
 * Rano (258e76bb) dołożyłem tu składnik `max(0px, 100lvh - 100dvh)`, czyli wysokość
 * paska przeglądarki, bo Piotr zgłosił, że pigułki Lista/Mapa NIE DA SIĘ dotknąć —
 * chowała się za dolnym paskiem Chrome'a. Założenie było takie, że `position: fixed`
 * kotwiczy się do dużego okna widoku, więc pasek leży NA pigułce.
 *
 * Założenie było błędne. Safari i Chrome na iOS trzymają element `fixed` NAD dynamicznym
 * paskiem, więc ten składnik dokładał wysokość paska drugi raz. Efekt zmierzył Piotr na
 * zrzucie: pigułka wisiała ~110 px nad paskiem, czyli mniej więcej o jedną jego wysokość
 * za wysoko. Prawdziwą przyczyną pierwotnego problemu było samo `bottom: 1.5rem` liczone
 * bez `env(safe-area-inset-bottom)` na telefonie z paskiem gestu.
 *
 * Zostaje więc to, co jest potrzebne i wystarczające: własny odstęp plus pasek gestu.
 */
export const ODSTEP_OD_DOLU = 'calc(0.75rem + env(safe-area-inset-bottom, 0px))';

/**
 * Odstęp dla noty o pinach — o jeden rząd WYŻEJ niż przełącznik Lista/Mapa.
 *
 * Zmierzone 27.09 na iPhonie: nota (x 12–303) i przełącznik (x 148–245) wylądowały w tym
 * samym wierszu, y 603–647, czyli jedno na drugim. Wcześniej tego nie było widać, bo nota
 * leżała poza ekranem — przesunięcie jej na `fixed` odsłoniło kolizję, której nikt nie
 * projektował. Przełącznik jest wyśrodkowany i ma 44 px wysokości; nota idzie nad niego,
 * z ośmiopikselowym prześwitem.
 *
 * Na pulpicie przełącznika nie ma, więc te 52 px to po prostu trochę wyżej nad dolną
 * krawędzią mapy — nie koliduje tam z niczym, a jedna wartość jest warta więcej niż dwie
 * rozjeżdżające się.
 */
export const ODSTEP_NAD_PRZELACZNIKIEM = 'calc(0.75rem + env(safe-area-inset-bottom, 0px) + 3.25rem)';

/**
 * Odstęp od dołu dla kart nad mapą NA PULPICIE — nad atrybucją, nie na niej.
 *
 * Zmierzone 27.09 nową bramką nachodzenia (1440×900): karuzela kart i atrybucja
 * („© OpenFreeMap…", prawy dolny róg) miały 299×22 px części wspólnej. Na telefonie tego nie
 * widać, bo tam atrybucja siedzi u góry po lewej, a karty odsuwa pigułka Lista/Mapa — czyli
 * usterka istniała tylko w układzie, którego nikt nie oglądał na zrzutach.
 *
 * Atrybucja ma 40 px wysokości (od 29.09 — przycisk „ⓘ” w stylu naszych kontrolek, cel dotyku
 * 40 px; wcześniej ~22 px i stało tu 2,25 rem) plus 10 px marginesu MapLibre; 3,5 rem = 56 px
 * zostawia ją całą widoczną pod kartami. Nie przesuwamy atrybucji, bo prawy dolny róg to
 * miejsce, w którym człowiek jej szuka — i zostaje ono wolne także wtedy, gdy kart nie ma.
 */
export const ODSTEP_NAD_ATRYBUCJA = '3.5rem';
